import React from 'react';

export default function StepLead({ data, updateData, onNext, onPrev, isSubmitting }) {
  const isValid = data.email && data.email.includes('@') && data.name;

  return (
    <div className="space-y-6 animate-fadeIn">
      <div className="text-center mb-6">
        <h3 className="text-xl font-bold text-gray-800">Bijna klaar!</h3>
        <p className="text-gray-600 mt-2">Vul uw gegevens in om uw persoonlijke prijsindicatie te bekijken.</p>
      </div>
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1 text-left">Uw naam *</label>
          <input
            type="text"
            required
            value={data.name}
            onChange={(e) => updateData({ name: e.target.value })}
            className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#154A48] outline-none"
            placeholder="Naam"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1 text-left">E-mailadres *</label>
          <input
            type="email"
            required
            value={data.email}
            onChange={(e) => updateData({ email: e.target.value })}
            className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#154A48] outline-none"
            placeholder="e-mailadres"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1 text-left">Telefoonnummer</label>
          <input
            type="tel"
            value={data.phone}
            onChange={(e) => updateData({ phone: e.target.value })}
            className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#154A48] outline-none"
            placeholder="Bijv. 0470 00 00 00"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1 text-left">Bedrijfsnaam</label>
          <input
            type="text"
            value={data.company}
            onChange={(e) => updateData({ company: e.target.value })}
            className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#154A48] outline-none"
            placeholder="Bedrijf"
          />
        </div>
      </div>
      <div className="flex gap-3 pt-4">
        <button
          onClick={onPrev}
          disabled={isSubmitting}
          className="px-6 py-3 rounded-lg font-medium text-gray-600 bg-gray-100 hover:bg-gray-200 transition-colors"
        >
          Terug
        </button>
        <button
          onClick={onNext}
          disabled={!isValid || isSubmitting}
          className="flex-1 bg-[#154A48] text-white py-3 rounded-lg font-bold hover:bg-[#0E3432] disabled:opacity-50 transition-colors flex items-center justify-center gap-2"
        >
          {isSubmitting ? (
            <>
              <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
              Verwerken...
            </>
          ) : (
            'Bekijk mijn prijs'
          )}
        </button>
      </div>
    </div>
  );
}